import axios from '../index'

export function getCart(params) {
  return axios.get('/ajax/clients/cart', { params })
}

export function addItem(cartItem) {
  return axios.post('/ajax/clients/cart/cart_items', { cartItem })
}

export function updatePlatformQuantity(platformId, quantity) {
  return axios.patch('/ajax/clients/cart/cart_items/update_quantity', {
    platformId,
    quantity
  })
}

export function removeItem(id) {
  return axios.delete(`/ajax/clients/cart/cart_items/${id}`)
}

export function clearItems() {
  return axios.delete('/ajax/clients/cart')
}

export function checkout() {
  return axios.post('/ajax/clients/cart/checkout')
}

export function woocommerceCheckout() {
  return axios.post('/ajax/clients/cart/woocommerce_checkout')
}
